'use strict';

angular.module('ntmApp').factory('ProfileFilters', ['ProfileHelper', 'ComplexSearchConstants', 'ProfileConstants', '$filter',
  function (ProfileHelper, ComplexSearchConstants, ProfileConstants, $filter) {

    function ProfileFilters() {

        var self = this;

        self.FilterGroupsConstants = ProfileConstants.FilterGroups;

        self.areFiltersPristine = true;
        var profileFilters = [];

        self.getRequestData = function (filters) {

            var data = {
                pageId: ProfileHelper.pageId
            };

            if (filters) {
                data.itemInformationFilters = getAppliedFiltersValues(getAppliedInformationFilters(filters));
                data.itemGridFilters = getAppliedFiltersValues(getAppliedGridFilters(filters));
                data.specificRecordFilters = getAppliedFiltersValues(getAppliedSpecificRecordFilters(filters));
            }

            return data;
        };

        self.buildFilters = function (filters) {
            profileFilters = [];

          filters.itemInformationFilters.forEach(function (item) {

            if (item.type === ComplexSearchConstants.ControlTypes.PICKLIST || item.type === ComplexSearchConstants.ControlTypes.AUTOCOMPLETE || item.type === ComplexSearchConstants.ControlTypes.CHECKBOXLIST) {
              properties = JSON.parse(item.properties);

              if (properties && properties.sort) {
                var order = [];
                properties.sort.forEach(function (sortItem) {
                  order.push(sortItem.order === 'DESC' ? '-{0}'.format(sortItem.field) : sortItem.field);
                });
                item.values = $filter('orderBy')(item.values, order);
              }
            }

                var itemInformationFilterItem = {
                    label: item.name,
                    type: item.type,
                    propertyObj: item.properties ? JSON.parse(item.properties) : item.properties,
                    template: getFilterTemplate(item.type),
                    values: item.values,
                    fieldName: item.fieldName,
                    sectionId: item.sectionId,
                    filtersGroup: self.FilterGroupsConstants.ItemInformation
                };

                itemInformationFilterItem = prepareItemInformationFilterTemplateData(itemInformationFilterItem);

                profileFilters.push(itemInformationFilterItem);
            });

            filters.itemGridFilters.forEach(function (item) {
                profileFilters.push({
                    label: item.name,
                    type: item.type,
                    values: item.values,
                    fieldName: item.fieldName,
                    sectionId: item.sectionId,
                    filtersGroup: self.FilterGroupsConstants.ItemGrid
                });
            });

            filters.specificRecordFilters.forEach(function (item) {
                var specificRecordFilterItem = {
                    label: item.name,
                    type: item.type,
                    propertyObj: item.properties ? JSON.parse(item.properties) : item.properties,
                    values: item.values,
                    fieldName: item.fieldName,
                    sectionId: item.sectionId,
                    filtersGroup: self.FilterGroupsConstants.SpecificRecord
                };

                specificRecordFilterItem = prepareSpecificRecordFilterTemplateData(specificRecordFilterItem);

                if (specificRecordFilterItem.values && specificRecordFilterItem.values.length > 0) {
                    profileFilters.push(specificRecordFilterItem);
                }
            });

            return profileFilters;
        };

        self.getAppliedFilters = function () {
            return profileFilters.filter(function (filterItem) { return filterItem.value; });
        };

        self.areFiltersApplied = function () {
            return self.getAppliedFilters().length;
        };

        self.clearAllFilters = function () {
            profileFilters.forEach(function (filterItem) {
                if (filterItem.value) {
                    filterItem.value = null;
                }
            });

            self.appliedFilters = [];
            self.areFiltersPristine = false;
        };

        self.getSimpleDisplayChip = function (filterItem) {
            var valueForText = getValueForSimpleDisplayChipText(filterItem);

            if (valueForText && valueForText !== '') {
                return '{0}: {1}'.format(filterItem.label, valueForText);
            }

            return '';
        };

        self.conditionChanges = function (changedFilterItem) {
            if (changedFilterItem) {
                var filterItemToRemove = findFilterItem(changedFilterItem);

                if (filterItemToRemove && filterItemToRemove.length && filterItemToRemove.length > 0) {
                    filterItemToRemove[0].value = null;
                }
            }

            self.areFiltersPristine = false;
        };

        self.onFiltersApplied = function () {
            self.appliedFilters = angular.copy(self.getAppliedFilters());

            self.areFiltersPristine = true;
        };

        self.onFiltersDialogCloseXClicked = function (callback) {
            if (!self.areFiltersPristine) {
                callback();
            }
        };


        //private methods

        function getFilterTemplate(type) {
            switch (type) {
                case ComplexSearchConstants.ControlTypes.TEXT:
                    return 'ng1/src/profilePages/controlTypeTemplates/text.html';
                case ComplexSearchConstants.ControlTypes.NUMERIC:
                    return 'ng1/src/profilePages/controlTypeTemplates/numeric.html';
                case ComplexSearchConstants.ControlTypes.CHECKBOX:
                    return 'ng1/src/profilePages/controlTypeTemplates/checkbox.html';
                case ComplexSearchConstants.ControlTypes.PICKLIST:
                case ComplexSearchConstants.ControlTypes.AUTOCOMPLETE:
                    return 'ng1/src/profilePages/controlTypeTemplates/picklist.html';
                case ComplexSearchConstants.ControlTypes.DROPLIST:
                    return 'ng1/src/profilePages/controlTypeTemplates/droplist.html';
                case ComplexSearchConstants.ControlTypes.CHECKBOXLIST:
                    return 'ng1/src/profilePages/controlTypeTemplates/checkboxlist.html';
                case ComplexSearchConstants.ControlTypes.DATE:
                    return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/date.html';
                case ComplexSearchConstants.ControlTypes.RADIO:
                    return 'ng1/src/profilePages/controlTypeTemplates/radio.html';
                case ComplexSearchConstants.ControlTypes.RADIOBOOLEAN:
                    return 'ng1/src/profilePages/controlTypeTemplates/radioboolean.html';
                default:
                    return 'ng1/src/reports/complexFilterControl/controlTypeTemplates/empty.html';
            }
        }

        function getValueForSimpleDisplayChipText(filterItem) {

            if (filterItem.type === ComplexSearchConstants.ControlTypes.CHECKBOX) {
                if (filterItem.value === true || filterItem.value === 'Checked') {
                    return 'Yes';
                }
                return 'No';
            }

            if (filterItem.type === ComplexSearchConstants.ControlTypes.CHECKBOXLIST && filterItem.value.length > 0) {
                var resultString = '';
                filterItem.value.forEach(function (item) { resultString += item.value + '; '; });

                return resultString;
            }

            if (filterItem.type === ComplexSearchConstants.ControlTypes.PICKLIST && filterItem.propertyObj.type && filterItem.propertyObj.type === 'STATUS_PICKER') {
                if (filterItem.value) {
                    return filterItem.value[filterItem.propertyObj.display[1]];
                }
            }

            return formatValueForSimpleDisplayChipText(filterItem);
        }

        function formatValueForSimpleDisplayChipText(filterItem) {

            if (!filterItem.value) {
                return '';
            }

            if (filterItem.type === ComplexSearchConstants.ControlTypes.DATE) {

                var formattedDate = moment(filterItem.value).format('MM/DD/YYYY');
                return '{0}'.format(formattedDate);
            }

            return '{0}'.format(filterItem.value);
        }

        function getFilterItemValue(filterItem) {
            if (filterItem.type === ComplexSearchConstants.ControlTypes.RADIOBOOLEAN || filterItem.filtersGroup === self.FilterGroupsConstants.ItemGrid) {
                if (filterItem.value === "Yes") {
                    return true;
                } else {
                    return false;
                }
            }

            if (filterItem.type === ComplexSearchConstants.ControlTypes.CHECKBOX) {
                if (filterItem.value === true || filterItem.value === 'Checked') {
                    return true;
                } else {
                    return false;
                }
            }

            if (filterItem.type === ComplexSearchConstants.ControlTypes.PICKLIST && filterItem.propertyObj.type && filterItem.propertyObj.type === 'STATUS_PICKER') {
                if (filterItem.value) {
                    return filterItem.value[filterItem.fieldName];
                }
            }

            if (filterItem.value.id) {
                return filterItem.value.id;
            }

            return filterItem.value;
        }

        function getAppliedFiltersValues(filters) {
            var requestFiltersDataArray = [];

            filters.forEach(function (filterItem) {
                requestFiltersDataArray.push({ fieldName: filterItem.fieldName, value: getFilterItemValue(filterItem), sectionId: filterItem.sectionId });
            });

            return requestFiltersDataArray;
        }

        function findFilterItem(filterItemToFind) {
            return profileFilters.filter(function (filterItem) { return filterItem.sectionId === filterItemToFind.sectionId && filterItem.fieldName === filterItemToFind.fieldName; });
        }

        function getAppliedInformationFilters(filters) {
            return filters.filter(function (filterItem) { return filterItem.filtersGroup === self.FilterGroupsConstants.ItemInformation && filterItem.value; });
        }

        function getAppliedGridFilters(filters) {
            return filters.filter(function (filterItem) { return filterItem.filtersGroup === self.FilterGroupsConstants.ItemGrid && filterItem.value; });
        }

        function getAppliedSpecificRecordFilters(filters) {
            return filters.filter(function (filterItem) { return filterItem.filtersGroup === self.FilterGroupsConstants.SpecificRecord && filterItem.value; });
        }

        function prepareItemInformationFilterTemplateData(filterItem) {
            switch (filterItem.type) {
                case ComplexSearchConstants.ControlTypes.CHECKBOXLIST:
                    var multiselectValuesObject = [];

                    if (filterItem.values && filterItem.values.length > 0) {
                        filterItem.values.forEach(function (filterItemValueItem) {
                            multiselectValuesObject.push({
                                id: filterItemValueItem[filterItem.propertyObj.key],
                                value: filterItemValueItem[filterItem.propertyObj.display[0]]
                            });
                        });
                    }

                    filterItem.values = multiselectValuesObject;

                    filterItem.multiSelectSettings = {
                        displayProp: 'value',
                        attachDisplayProp: true,
                        smartButtonMaxItems: 10,
                        scrollableHeight: '200px',
                        enableSearch: true
                    };

                    filterItem.multiSelectEvents = {
                        onItemSelect: function () {
                            self.areFiltersPristine = false;
                        },
                        onItemDeselect: function () {
                            self.areFiltersPristine = false;
                        },
                        onDeselectAll: function () {
                            self.areFiltersPristine = false;
                        }
                    };

                    break;
            }

            return filterItem;
        }

        function prepareSpecificRecordFilterTemplateData(filterItem) {
            var filterType = filterItem.type === 'PICKLIST' || filterItem.type === 'AUTOCOMPLETE' || filterItem.type === 'TEXT' || filterItem.type === 'CHECKBOX' ? 'PICKLIST' : 'DROPLIST';

            filterItem.template = getFilterTemplate(filterType);

            switch (filterItem.type) {
                case ComplexSearchConstants.ControlTypes.CHECKBOX:
                    filterItem.propertyObj = { display: ['SpecificRecordFilterDisplay'], key: filterItem.fieldName};

                    filterItem.values = [
                        {
                            [filterItem.propertyObj.display]: 'Checked',
                            [filterItem.propertyObj.key]: true
                        },
                        {
                            [filterItem.propertyObj.display]: 'Unchecked',
                            [filterItem.propertyObj.key]: false
                        }
                    ];

                    break;
            }

            return filterItem;
        }
    }

    return (ProfileFilters);
}]);
